<template>
  <flow-command :name="command">
    <span class="material-icons-round" :title='text || ""'>
      {{ icon }}
    </span>
  </flow-command>
</template>

<script>
import { Command } from 'vg-editor';

export default {
  name: 'ToolbarButton',

  props: ['command', 'icon', 'text'],

  components: {
    FlowCommand: Command,
  },
};
</script>
